import { createStore } from "react-hooks-global-state/dist";

import { IQuoteFormValues } from "./types";

export enum types {
  SAVE_QUOTE_FORM = "saveQuoteForm",
  RESPONSE_SAVE_QUOTE_FORM = "responseSaveQuoteForm",
  GET_QUOTE_FORM_BY_ID = "getQuoteFormById",
  RESPONSE_GET_QUOTE_FORM = "responseGetQuoteForm",
  REQUOTE_FORM = "requoteForm",
  OFFER_SELECTED = "offerSelected"
}

export type Action =
  | {
      type: types.SAVE_QUOTE_FORM;
    }
  | {
      type: types.RESPONSE_SAVE_QUOTE_FORM;
      form: IQuoteFormValues;
    }
  | {
      type: types.GET_QUOTE_FORM_BY_ID;
      formId: string;
    }
  | {
      type: types.RESPONSE_GET_QUOTE_FORM;
      form?: IQuoteFormValues;
    }
  | {
      type: types.REQUOTE_FORM;
      formId: string;
    }
  | {
      type: types.OFFER_SELECTED;
      formId: string;
      offerId: string;
    };

export interface IState {
  form?: IQuoteFormValues;
  isLoading: boolean;
  requoteForm: boolean;
}

const reducer = (state: IState, action: Action) => {
  switch (action.type) {
    case types.SAVE_QUOTE_FORM:
      return {
        ...state,
        isLoading: true
      };
    case types.RESPONSE_SAVE_QUOTE_FORM:
      return {
        ...state,
        form: action.form,
        isLoading: false,
        requoteForm: false
      };
    case types.GET_QUOTE_FORM_BY_ID:
      return {
        ...state,
        isLoading: true
      };
    case types.RESPONSE_GET_QUOTE_FORM:
      return {
        ...state,
        form: action.form,
        isLoading: false
      };
    case types.REQUOTE_FORM:
      return {
        ...state,
        form: undefined,
        requoteForm: true
      };
    default:
      return state;
  }
};

const initialState: IState = {
  form: undefined,
  isLoading: false,
  requoteForm: false
};

export const {
  GlobalStateProvider: QuoteFormStateProvider,
  dispatch,
  useGlobalState: useQuoteFormState,
  getState: getQuoteFormState
} = createStore(reducer, initialState);
